export default __webpack_public_path__ + "locales/sr-Latn-RS/EmptyTrashDialog.json?hash=3e7915eb8a8358709d055fb6b642939e";